import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import qs from 'qs'

function filterQS (url) {
  if (!url || !url.split('?')[1]) return url
  let base = url.split('?')[0]
  let qs = ''
  if (!url.split('?')[1]) {
    qs = url.split('?')[1].split('&').filter(q => q.split('=')[0] !== 'token').join('&')
  }
  return base + '?' + qs
}

let query = qs.parse(document.location.hash.split('?')[1])
if (query && query.sentry && query.sentry === 'true') {
  Sentry.init({
    release: require('../../package.json').name + require('../../package.json').version,
    dsn: require('../../package.json').sentry,
    beforeSend (event) {
      event.request.url = filterQS(event.request.url)
      return event
    },
    integrations: [new Integrations.Vue({Vue, attachProps: false})]
  })
}
